import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MobileHomePage } from '@/pages/mobile/MobileHomePage';
import { DesktopHomePage } from '@/pages/desktop/DesktopHomePage';
import { BottomNavigation } from '@/components/common/BottomNavigation';
import { WebViewBanner } from '@/components/common/WebViewBanner';
import { ServiceTerminationNotice } from '@/components/common/ServiceTerminationNotice';
import { useAuth } from '@/contexts/AuthContext';
import { SEO } from '@/components/seo/SEO';
import { CANONICAL_URLS } from '@/utils/canonicalUrl';

const SERVICE_NOTICE_STORAGE_KEY = 'ecodeal-service-termination-notice-2026-03-10';

export function HomePage() {
  const { user, isLoading, hasSession } = useAuth();
  const navigate = useNavigate();
  const [isNoticeOpen, setIsNoticeOpen] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }

    return localStorage.getItem(SERVICE_NOTICE_STORAGE_KEY) !== 'dismissed';
  });

  const handleNoticeConfirm = () => {
    localStorage.setItem(SERVICE_NOTICE_STORAGE_KEY, 'dismissed');
    setIsNoticeOpen(false);
  };

  // 사용자 역할에 따른 리다이렉션 처리
  useEffect(() => {
    if (!isLoading && !isNoticeOpen && hasSession && user?.role === 'seller') {
      console.log('[HomePage] Seller detected, redirecting to seller home');
      navigate('/seller/home', { replace: true });
    }
  }, [user, isLoading, hasSession, navigate, isNoticeOpen]);

  // 로딩 중일 때 로딩 화면 표시
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500 mx-auto mb-4"></div>
          <p className="text-gray-600">로그인 상태 확인 중...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <SEO 
        title="에코딜 - 최소 40% 할인, 지구까지 생각한 똑똑한 소비"
        description="마감할인 40-50%! 에코딜에서 음식물쓰레기를 줄이고 할인받으세요. 김밥, 도시락, 샐러드 등 다양한 음식을 저렴하게 픽업하세요."
        canonical={CANONICAL_URLS.HOME}
      />
      
      {/* WebView 감지 배너 - 모바일에서만 표시 */}
      <div className="lg:hidden">
        <WebViewBanner />
      </div>
      
      {/* 1024px 미만에서만 표시 - 모바일 페이지 */}
      <div className="lg:hidden">
        <div className="mobile-container bg-gray-100 min-h-screen relative">
          <MobileHomePage />
          <BottomNavigation activeId="home" />
        </div>
      </div>
      
      {/* 1024px 이상에서만 표시 - 데스크톱 페이지 */}
      <div className="hidden lg:block">
        <DesktopHomePage />
      </div>

      {isNoticeOpen && <ServiceTerminationNotice onConfirm={handleNoticeConfirm} />}
    </>
  );
}
